import { GET_STATEMENTS } from "constants/statements";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_STATEMENTS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
